import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map, takeWhile } from 'rxjs';
import { environment } from '../../environments/environment';
import { ChatMessage, ChatSession } from '../_models/chat.models';
import { sseStream } from '../_helpers/sse-stream';

export interface StreamEvent {
  type:    'status' | 'chunk' | 'history' | 'done' | 'error';
  payload: string;
}

@Injectable({ providedIn: 'root' })
export class AgentChatService {
  private readonly http    = inject(HttpClient);
  private readonly baseUrl = `${environment.localApiUrl}agent/chat`;

  createSession(orgId: number): Observable<ChatSession> {
    return this.http.post<ChatSession>(`${this.baseUrl}/session`, { orgId });
  }

  deleteSession(sessionId: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/session/${sessionId}`);
  }

  getHistory(sessionId: string): Observable<ChatMessage[]> {
    return this.http.get<ChatMessage[]>(`${this.baseUrl}/session/${sessionId}/history`);
  }

  // SSE streaming con named events (parser condiviso in _helpers/sse-stream.ts, feature 159).
  sendMessage(sessionId: string, message: string, token: string): Observable<StreamEvent> {
    const url = `${this.baseUrl}/stream/${sessionId}?message=${encodeURIComponent(message)}`;
    return sseStream({url, token}).pipe(
      map((evento): StreamEvent => ({
        type: (evento.type === 'message' ? 'chunk' : evento.type) as StreamEvent['type'],
        payload: evento.data.replace(/\\n/g, '\n')
      })),
      takeWhile(evento => evento.type !== 'done' && evento.type !== 'error', true)
    );
  }
}
